import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SettingsPageActions } from './settings.actions';
import { tap } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { ApplicationActions } from '@lyceo/shared/data-access';
import { SettingsFacade } from './settings.facade';
import { setDefaultOptions } from 'date-fns';
import { getDateFnsLocaleByLanguage } from '@lyceo/homi/settings/util';
import { Language } from '@lyceo/homi/settings/util-models';

@Injectable()
export class SettingsEffects {
  private readonly actions$ = inject(Actions);
  private readonly translocoService: TranslocoService =
    inject(TranslocoService);
  private readonly settingsFacade: SettingsFacade = inject(SettingsFacade);

  public setActiveLanguageOnInit$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(ApplicationActions.init),
        tap(() => {
          const language: Language = this.settingsFacade.language();
          setDefaultOptions({
            locale: getDateFnsLocaleByLanguage(language),
          });
          this.translocoService.setActiveLang(language);
        }),
      );
    },
    { dispatch: false },
  );

  public setActiveLanguage$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(SettingsPageActions.languageChanged),
        tap((action) => {
          setDefaultOptions({
            locale: getDateFnsLocaleByLanguage(action.language),
          });
          this.translocoService.setActiveLang(action.language);
        }),
      );
    },
    { dispatch: false },
  );
}
